<!-- Тип, критичность и состояние пометки в списке и подробной карточке. -->
<template>
  <div class="vehicle-remark-badges">
    <span class="vehicle-remark-badges__type">
      {{
        remark.remark_type === "defect"
          ? "Неисправность"
          : "Информация"
      }}
    </span>
    <span
      v-if="remark.remark_type === 'defect'"
      class="vehicle-remark-badges__badge"
      :class="`vehicle-remark-badges__badge--${
        remark.severity || 'unknown'
      }`"
    >
      {{ severityLabel }}
    </span>
    <span
      v-if="showStatus"
      class="vehicle-remark-badges__badge"
      :class="`vehicle-remark-badges__badge--${remark.status}`"
    >
      {{ statusLabel }}
    </span>
  </div>
</template>
<script>
import searchFields from "@/config/filters/vehicle/remarks.json";
const remarkSeverities = searchFields.find((field) => field.value === "severity").options;
const remarkStatuses = searchFields.find((field) => field.value === "status").options;
export default {
  name: "VehicleRemarkSharedBadges",
  props: {
    remark: { type: Object, required: true },
    showStatus: { type: Boolean, default: true },
  },
  computed: {
    severityLabel() {
      return (
        remarkSeverities.find(
          (item) => item.value === this.remark.severity
        )?.label || "Критичность не указана"
      );
    },
    statusLabel() {
      return remarkStatuses.find((item) => item.value === this.remark.status)?.label;
    },
  },
};
</script>
<style scoped>
.vehicle-remark-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  line-height: 1.4;
}
.vehicle-remark-badges__type {
  color: #64748b;
  margin-right: 2px;
}
.vehicle-remark-badges__badge {
  padding: 4px 7px;
  border-radius: 5px;
  font-weight: 500;
  background: #f1f5f9;
  color: #475569;
}
.vehicle-remark-badges__badge--blocking {
  background: #fff0ef;
  color: #b43434;
}
.vehicle-remark-badges__badge--important {
  background: #fff6df;
  color: #93630c;
}
.vehicle-remark-badges__badge--open {
  background: #eef2ff;
  color: #495fbd;
}
.vehicle-remark-badges__badge--in_progress {
  background: #fff6df;
  color: #93630c;
}
.vehicle-remark-badges__badge--resolved {
  background: #e7f7f0;
  color: #147653;
}
.vehicle-remark-badges__badge--unknown {
  border: 1px dashed #cbd5e1;
  background: transparent;
}
</style>
